import "./Switch.css";

const Switch = ({
  checked,
  onChange,
  label,
  disabled = false,
}) => {
  return (
    <label className={`ui-switch ${disabled ? "disabled" : ""}`}>
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />

      <span className="ui-switch-track">
        <span className="ui-switch-thumb" />
      </span>

      {label && <span>{label}</span>}
    </label>
  );
};

export default Switch;